module.exports = __webpack_public_path__ + "img/img_customers_06.49eaa2ea.png";